// eslint-disable-next-line
import ImageWorker from 'worker-loader!./ImageWorker.worker';
import * as Comlink from 'comlink';
import { imageFetcher, ImageFetcher } from './ImageWorkerModel';

let worker: Comlink.Remote<ImageFetcher> | ImageFetcher;

export function getImageFetchers(): Comlink.Remote<ImageFetcher> | ImageFetcher {
	if (window.Worker) {
		worker = worker || Comlink.wrap(new ImageWorker());
	} else {
		worker = imageFetcher;
	}
	return worker;
}
